import { AxiosError } from "axios";
import { IMiddleResponse } from "./middlewareTypes";

export enum ReportType {
  REPORT_PENDING = "REPORT_PENDING",
  REPORT_SUCCESS = "REPORT_SUCCESS",
  REPORT_ERROR = "REPORT_ERROR",
}

export interface IParamReport {
  Limit?: number;
  Page?: number;
  Search?: string;
  search?: string;
  Status?: string;
  StartDate?: string;
  EndDate?: string;
  Id?: number;
  type?: string;
  Destination?: string;
  Product?: any;
  Payment?: string;
  OrderType?: any;
  keyword?: string;
  size?: number;
  current?: number;
  switch?: string;
  startDate?: string;
  status?: string;
  endDate?: string;
}

export interface IReportDataMaster {
  trxId: number;
  trxClientId: number;
  trxMemberId: number;
  trxType: number;
  trxOrderType: string;
  trxPaymentType: string;
  trxDate: string;
  trxReceipt: string;
  trxUser: string;
  trxStatus: string;
  trxPhone: string;
  trxPayload: string;
  pGroup: string;
  pName: string;
  mArea: string;
}

export interface IReportResponseMaster {
  Code: number;
  Status: string;
  Message: string;
  Data: IReportDataMaster;
  Paginate: {
    CurrentPage: number;
    NextPage: number;
    PrevPage: number;
    TotalPage: number;
    TotalRow: number;
  };
}

export interface IParamReportQris {
  switch?: string;
  startDate?: string;
  type?: string;
  endDate?: string;
  status?: string;
  current?: number;
  size?: number;
  keyword?: string;
  paymentMethod?: string;
}

export interface IParamReportDetail {
  id?: string;
}

export interface IMiddlewareBodyReportIn {
  ClientId: number;
  Subject: "ewallet";
  SubjectType: "webreport" | "web-report";
  SubjectIdentifier:
    | "qris"
    | "ppob"
    | "topup"
    | "transferout"
    | "voucher"
    | "all"
    | "list_order_type"
    | "product"
    | "report";
  Action:
    | "master"
    | "detail"
    | "export"
    | "qris-v2-get-page"
    | "topup-bca-get-page"
    | "get-report-transaction-detail"
    | "get-report-transaction-voucher-detail"
    | "get-report-voucher-get-page";
  ResourceType: "null" | "data";
  Resource: "null" | "data";
  ResourceId: "null" | "data";
  UserId: string;
  Date: string;
  ScopePlatform?: "private";
  Platform?: "qoin-apps";
  Data: IParamReport | IParamReportQris | IParamReportDetail;
}

export interface IMiddlewareBodyReportOut {
  TicketId: string;
  Subject: "ewallet";
  SubjectType: "webreport" | "web-report";
  SubjectIdentifier:
    | "qris"
    | "ppob"
    | "topup"
    | "transferout"
    | "voucher"
    | "all"
    | "list_order_type"
    | "product"
    | "report";
}

export interface IMiddlewareResponseReportOut {
  ClientId: number;
  Subject: "ewallet";
  SubjectType: "webreport";
  SubjectIdentifier:
    | "qris"
    | "ppob"
    | "topup"
    | "transferout"
    | "voucher"
    | "all"
    | "list_order_type"
    | "product";
  Action: "master" | "detail" | "export";
  ResourceType: null;
  Resource: null;
  ResourceId: null;
  UserId: string;
  Date: string;
  Result: IReportResponseMaster | any;
  Status?: string;
  StatusCode?: number;
}

interface GetReportAction {
  type: ReportType.REPORT_SUCCESS;
  payload: {
    data: IMiddlewareResponseReportOut | IMiddleResponse | null;
  };
}

interface SetLoadingReportAction {
  type: ReportType.REPORT_PENDING;
  payload?: {
    data: any;
  };
}

interface SetErrorReportAction {
  type: ReportType.REPORT_ERROR;
  payload: {
    error: AxiosError;
  };
}

export interface IReportState {
  data: IMiddlewareResponseReportOut | IMiddleResponse;
  isLoading: boolean;
  error: AxiosError;
  dataDetail: any;
  isLoadingDetail: boolean;
  dataExport: any;
  isLoadingExport: boolean;
  isLoadingDDl: boolean;
}

export type ReportAction =
  | GetReportAction
  | SetLoadingReportAction
  | SetErrorReportAction;
